<div *ngIf="dock!= 0; else selectDock" style="font-size: 8vh; font-weight: bold; padding: 0; margin-top: 10%;">
    <p style=" line-height: 0px;margin-top: 40px;">{{dock}}</p>
</div>
<ng-template #selectDock>
    <p class="dock-title">Selecione uma doca</p>
</ng-template>
